<template lang="pug">
transition(name="modal")
  .modal-mask
    .modal-wrapper.modal.mt-5
      .modal-dialog(role="document")
        .modal-content
          .modal-header
            h3.modal-title Postcode finder
            button.close(type="button", @click="$modal.close()")
              span(aria-hidden="true") &times;
          .modal-body
            delivery-location-picker(@location-selected="locationSelected")
            button.btn.btn-success.btn-block.mt-3(:class="{ 'is-loading': isLoading }" :disabled="!postcode", @click="usePostcode()")
              span(v-if="postcode") Use {{postcode}}
              span(v-else) Please choose valid location
</template>

<script>
import { mapGetters } from 'vuex'

import api from '@/api'
import DeliveryLocationPicker from '../components/DeliveryLocationPicker.vue'

export default {
  components: { DeliveryLocationPicker },
  props: ['eventbus', 'validateDelivery'],
  data () {
    return {
      isLoading: false,
      postcode: null
    }
  },
  computed: {
    ...mapGetters({
      cartRestaurant: 'getCartRestaurant',
      orderDeliveryType: 'getOrderDeliveryType'
    })
  },
  methods: {
    locationSelected (lat, lng) {
      this.isLoading = true
      var latlng = new window.google.maps.LatLng(lat, lng)
      var geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({'location': latlng}, (results, status) => {
        this.isLoading = false
        if (status === 'OK') {
          var postcode = null
          var countryCode = null
          if (results[0]) {
            results[0].address_components.forEach(item => {
              if (item.types.indexOf('postal_code') !== -1) {
                postcode = item.short_name
              }
              if (item.types.indexOf('country') !== -1) {
                countryCode = item.short_name
              }
            })
          }

          if (this.validateDelivery) {
            api.get(`/postcodes/${postcode.replace('-', '')}/?restaurant_public_id=${this.cartRestaurant.public_ident}`)
            .then(response => {
              if (response.data.hot_delivery_supported) {
                this.postcode = postcode
              } else {
                this.cantDeliver = false
              }
            })
          } else {
            this.postcode = postcode && countryCode === 'JP' ? postcode : null
          }
        }
      })
    },
    usePostcode () {
      this.eventbus.$emit('updated', this.postcode)
      this.$modal.close()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/PostcodePickerModal.vue